import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { SupabaseHealthView } from './SupabaseHealthView';

const route: FuseRouteItemType = {
	path: 'health/supabase',
	element: <SupabaseHealthView />
};

export default route;
